import { render } from "./Devices.vue?vue&type=template&id=2b5a8915&scoped=true"
import script from "./Devices.vue?vue&type=script&lang=js"
export * from "./Devices.vue?vue&type=script&lang=js"

import "./Devices.vue?vue&type=style&index=0&id=2b5a8915&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2b5a8915"]])

export default __exports__